import { faClose, IconDefinition } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

import InfoIcon from 'assets/png/info-circle.png';

import { Button, Modal } from '../index';

export interface Props {
  infoDescription?: string;
  infoMessage?: string;
  isOpen: boolean;
  handleClose: VoidFunction;
}
const InfoModal = ({ isOpen, handleClose, infoMessage = 'information', infoDescription }: Props) => {
  const { t } = useTranslation();
  return (
    <Modal dataCy="info-modal" isOpen={isOpen} isDisableOutsideClick isError hideCross onClose={handleClose}>
      <div className="flex justify-between">
        <div className="flex items-center justify-left">
          <img src={InfoIcon} alt="Info icon" className="w-6 h-6" />
          <div className="text-black-900 dark:text-white-00 text-lg ml-3">{t(infoMessage)}</div>
        </div>
        <Button
          dataCy="close-button-icon"
          className="bg-transparent dark:bg-transparent p-0 w-8 h-8 block rounded-full hover:bg-neutral-100 dark:hover:bg-neutral-900 active:bg-neutral-100 dark:active:bg-neutral-900"
          onClick={handleClose}
        >
          <FontAwesomeIcon
            className="w-5 h-5 text-neutral-600 dark:text-neutral-300"
            icon={faClose as IconDefinition}
          />
        </Button>
      </div>

      {infoDescription && (
        <div className="text-center mt-4 text-neutral-700 dark:neutral-300 text-bodyMd">{t(infoDescription)}</div>
      )}

      <div className="flex justify-center mt-5 mb-4">
        <Button dataCy="info-modal-confirm-button" onClick={handleClose}>
          {t('Ok')}
        </Button>
      </div>
    </Modal>
  );
};

export default InfoModal;
